module.exports = __webpack_public_path__ + "img/favicon.76c5cbb.png";